import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const EliminarPlan = async (values) => {
    try {
        const resultado = await instance.Backend.post("/InformeConservacion/EliminarPlan",values, customConfig);

        return resultado

    } catch (error) {

        console.log(error);

    }

}
export { EliminarPlan };
